<template>
  <div class="main">
    <div class="content">
      <div class="main-lt">
        <ul class="elevator-nav">
          <li
            v-for="(item, index) in sections"
            :key="index"
            :class="{ active: currentSection === index }"
            @click="scrollTo(index)"
          >
            <img :src="item.img" alt="" class="li-img" /> {{ item.name }}
            <img :src="item.tag" class="li-tag" v-if="item.tag" />
          </li>
        </ul>
      </div>
      <div class="main-rg">
        <div class="main-rg-content">
          <div class="main-rg-top-img"></div>
          <div class="main-rg-top-text">专注语义智能 服务类脑决策</div>
        </div>
        <div class="input_inner">
          <!-- <input placeholder="请输入内容" class="input" />
          <div class="input_btn">搜索</div> -->
        </div>

        <div
          :ref="'section' + indexs"
          class="section"
          :id="indexs"
          v-for="(items, indexs) in list"
          :key="indexs"
        >
          <div style="display: flex; align-items: center; margin-bottom: 60px">
            <img v-if="items.img" :src="items.img" class="section-imgs" />
            <div v-else class="line"></div>
            <div class="list_title">{{ items.name }}</div>
          </div>
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in items.children"
              :key="index"
              @click="openUrl(item.url)"
            >
              <img class="item-tag" v-if="item.tag" :src="item.tag" />
              <img class="item_img" :src="item.img" />
              <div class="item_rg">
                <div class="item_title">{{ item.name }}</div>
                <div class="item_subtitle">
                  {{ item.subtitle }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="imgs">
        <div class="imgs-s">
          <img src="@/assets/qrcode.png" alt="" class="qrcode" />
          <div class="footer-text">联系我们</div>
        </div>
        <div class="imgs-s">
          <img src="@/assets/qrcode2.png" alt="" class="qrcode" />
          <div class="footer-text">关注中科凡语</div>
        </div>
      </div>
      <div class="footer-content">
        <!-- logo -->
        <div class="footer-logo"></div>
        <div class="footer-text" style="font-weight: bold">
          北京中科凡语科技有限公司
        </div>
        <div class="footer-text">地址：北京市海淀区丹棱街18号创富大厦405</div>
        <div class="footer-text">
          电话：010-61934588 &nbsp; 手机：13911717727
        </div>
        <div class="footer-text">邮箱：hanyanchao@zkfy.com</div>
        <div class="footer-text texts">
          <span>网址：</span
          ><span class="link" @click="openUrl('https://www.zkfy.com')"
            >https://www.zkfy.com</span
          >
        </div>
        <div class="footer-text" style="font-weight: bold">
          中科凡语(武汉)科技有限公司
        </div>
        <div class="footer-text">
          地址：湖北省武汉市东湖新技术开发区华工科技园现代服务业基地2号楼801
        </div>
        <div class="footer-text">
          电话：027-81308166 &nbsp; 手机：13675824675
        </div>
        <div class="footer-text">邮箱：lichang@zkfy.com</div>
        <div class="footer-text">
          <span>网址：</span
          ><span class="link" @click="openUrl('https://www.zkfy.com')"
            >https://www.zkfy.com</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegRated',
  data() {
    return {
      sections: [
        {
          name: '凡语大模型',
          img: require('@/assets/afy.png'),
          tag: require('@/assets/hm.png')
        },
        {
          name: '凡语垂直模型',
          img: require('@/assets/afycz.png'),
          tag: require('@/assets/hm.png')
        },
        { name: '智能翻译', img: require('@/assets/azn.png') },
        { name: '数据汇聚', img: require('@/assets/asj.png') },
        { name: '文档解析', img: require('@/assets/awd.png') },
        { name: '智能审校', img: require('@/assets/aznsh.png') },
        { name: '智训工具', img: require('@/assets/azxgj.png') }
      ],
      list: [
        {
          name: '凡语大模型',
          img: require('@/assets/hm.png'),
          children: [
            {
              name: '飞语大模型',
              img: require('@/assets/fydmx.png'),
              tag: require('@/assets/re.png'),
              url: 'http://aidoc.policy-ai.com/#/smartReply',
              subtitle:
                '基于自然语言处理技术，支持单文档与多文档的快速解析、内容检索与智能问答，助力高效获取关键信息与知识。'
            },
            {
              name: '智策大模型',
              img: require('@/assets/zcdmx.png'),
              tag: require('@/assets/re.png'),
              url: 'https://zkmx.zkfy.com/#/login',
              subtitle:
                '基于自然语言处理技术的大型智能工具，自动生成高质量研究报告，并从本地及互联网检索相关资料，提升报告撰写效率，辅助用户决策。'
            }
          ]
        },
        {
          name: '凡语垂直模型',
          img: require('@/assets/hm.png'),
          children: [
            {
              name: '政策模型',
              img: require('@/assets/zcmx.png'),
              tag: require('@/assets/xin.png'),
              url: 'https://zce.zkfy.com/#/login',
              subtitle:
                '政策大模型，具有政策问答、政策检索、文本生成等功能，利用海量中昌数据和大语言模型为用户提供快速精准的政策服务。。'
            },
            {
              name: '化工模型',
              img: require('@/assets/hgmx.png'),
              tag: require('@/assets/xin.png'),
              url: 'https://hua.zkfy.com/#/home',
              subtitle:
                '结合数据采集与自然语言处理技术的综合数据平台，汇聚文献、实验数据等多种数据源，助力化工领域的深度分析与研究。'
            },
            {
              name: '医疗模型',
              img: require('@/assets/ylmx.png'),
              url: 'http://zshp.zkfy.com/#/login',
              subtitle:
                '面向人工智能教学与科研实践，涵盖医疗实体挖掘、知识图谱构建、相似病历检索、疾病诊断与治疗方案推荐等关键能力。'
            },
            {
              name: '教育模型',
              img: require('@/assets/jymx.png'),
              url: 'http://fyea.zkfy.com/login',
              subtitle:
                '结合大语言模型与知识库构建校园AI助手,嵌入多元校园场景，聚焦师生关注问题，贯穿管理与生活全流程，提供个性化、智能化服务体验。'
            }
          ]
        },
        {
          name: '智能翻译',
          children: [
            {
              name: '飞译人机合译平台',
              img: require('@/assets/feiyi-pic.png'),
              url: 'https://univ.fycat.com',
              subtitle:
                '一款融合智能辅助翻译与教学实践功能的翻译系统，支持高效开展翻译训练与译后编辑教学。'
            },
            {
              name: '通用翻译系统',
              img: require('@/assets/fanyi-pic.png'),
              url: 'https://fanyi.zkfy.com',
              subtitle:
                '基于深度神经网络，支持78种语种及多种格式翻译，广泛应用于政府、航空、科技等领域，提供高质量的多场景翻译服务。'
            },
            {
              name: '科技文献翻译系统',
              img: require('@/assets/doc-pic.png'),
              url: 'http://111.46.204.97:10021/#/transHome',
              subtitle:
                '面向多语种科技文献的机器翻译平台，支持英、日、俄等语种与中文互译，提供专业词汇、文本及多格式文档翻译服务。'
            },
            {
              name: '低资源小语种图像文档翻译',
              img: require('@/assets/lan-pic.png'),
              url: 'http://111.46.204.86:23031/',
              subtitle:
                '支持藏语、波斯语、印地语等小语种文档的文字检测、识别与翻译，自动翻译并按原格式展示，提高文档处理效率与准确性。'
            }
          ]
        },
        {
          name: '数据汇聚',
          children: [
            {
              name: '全网态势洞知平台',
              img: require('@/assets/dzpt.png'),
              url: 'https://www.zkfy.com/open-mining/',
              subtitle:
                '融合自然语言处理技术的情报智能挖掘与分析工具，支持对各国主流媒体信息的深度解析与关联融合，助力全面掌握全球舆情态势。'
            },
            {
              name: '政策法规库',
              img: require('@/assets/zcfgz.png'),

              url: 'http://111.46.204.95:8088/#/homePage',
              subtitle:
                '融合智能检索与语义分析能力的政策法规信息服务平台，支持高效获取权威法规与政策条文。'
            },
            {
              name: '智能外交信息服务平台',
              img: require('@/assets/znwj.png'),
              url: 'http://111.46.204.81:23123/home',
              subtitle:
                '面向外交官群体的信息服务平台，支持科技文章的搜索、筛选、推荐与收藏，助力高效获取专业内容与知识。'
            }
          ]
        },
        {
          name: '文档解析',
          children: [
            {
              name: '多语言OCR识别系统',
              img: require('@/assets/dyy.png'),

              url: 'https://www.zkfy.com/OcrPlatformNginx/#/ocrFile',
              subtitle:
                '用于识别图片、文档、卡证等文件所包含的文字信息。支持30多个语种复杂格式文档识别、文档格式还原等。'
            }
          ]
        },
        {
          name: '智能审校',
          children: [
            {
              name: '飞校平台',
              img: require('@/assets/fxpt.png'),
              url: 'https://www.fycat.cn/',
              subtitle:
                '集公文编辑与智能纠错功能的文本审校工具，能够自动检测和修正文档中的语法、拼写和格式错误，提升公文的准确性，助力高效文档处理。'
            },
            {
              name: '智能标书系统',
              img: require('@/assets/znbs.png'),
              url: 'http://111.46.204.76:18082/',
              subtitle:
                '集成智能撰写、标书审校与企业智库功能，全面提升标书编制的效率与质量，助力企业高效投标、提升竞争力。'
            }
          ]
        },
        {
          name: '智训工具',
          children: [
            {
              name: '数据标注平台',
              img: require('@/assets/sjbz.png'),
              url: 'https://anno.fycat.com/#/login',
              subtitle:
                '集成多种标注应用的高效AI数据标注平台,支持团队协同与统一管理，涵盖图像和文本等多类型数据标注。'
            },
            {
              name: '语料库',
              img: require('@/assets/ylk.png'),
              url: 'http://111.46.204.77:18094/',
              subtitle:
                '智能化的语言数据管理平台，提供高质量的文本数据支持，助力翻译、语言研究与自然语言处理。'
            },
            {
              name: '爬虫平台',
              img: require('@/assets/pcpt.png'),
              url: 'http://111.46.204.85:82',
              subtitle:
                '一体化数据采集平台，整合网页采集、存储与挖掘服务，支持论坛帖子与回复采集、图片本地化、网站登录与分页采集、多格式文件采集。'
            },
            {
              name: '多模态数据获取与挖掘平台',
              img: require('@/assets/dmtpt.png'),
              url: 'http://192.168.96.37:18012/literatureScreeningSystem/literatureAcquisition',
              subtitle:
                '集成多源数据采集、融合与智能分析能力，为材料研究提供高效、精准的数据支撑。'
            }
          ]
        }
      ],
      currentSection: 0,
      isClickScrolling: false,
      timer: null
    }
  },
  mounted() {
    this.initEventListener()
  },
  methods: {
    openUrl(url) {
      if (!url) return alert('暂未开放')
      window.open(url)
    },
    scrollTo(index) {
      this.isClickScrolling = true
      const section = this.$refs['section' + index][0]
      if (index === 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth'
        })
      }

      this.currentSection = index
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.isClickScrolling = false
      }, 800)
    },
    getCurrentSection() {
      let current = null
      let minDistance = Infinity
      const sections = document.querySelectorAll('.section')
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect()
        const center = window.innerHeight / 2
        const distance = Math.abs(rect.top + rect.height / 2 - center)
        if (distance < minDistance) {
          minDistance = distance
          current = section
        }
      })

      return current?.id
    },
    initEventListener() {
      window.addEventListener('scroll', () => {
        if (this.isClickScrolling) return
        const currentId = this.getCurrentSection()
        if (this.currentSection === Number(currentId)) return
        this.currentSection = Number(currentId)
      })
    }
  }
}
</script>

<style scoped >
.main {
  background: url('@/assets/main-bg.png') no-repeat;
  background-size: cover;
}
.content {
  width: 100vw;
  padding: 25px 25px 0 25px;
  display: flex;
}
.main-lt {
  height: calc(100vh - 50px);
  width: 270px;
  margin-right: 15px;
}
.elevator-nav {
  width: 220px;
  position: fixed;
  top: 25px;
  left: 45px;
}
.elevator-nav li {
  list-style: none;
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-bottom: 4px;
  margin: 10px 0;

  font-weight: bold;
  font-size: 16px;
  /* color: #ffffff; */
  cursor: pointer;
  padding-left: 50px;
  line-height: 42px;
  display: flex;
  align-items: center;
  position: relative;
}
/* 第一个li */
.elevator-nav li:first-child {
  margin-top: 0;
}

.li-img {
  width: 22px;
  height: 22px;
  margin-right: 9px;
}
.li-tag {
  width: 14px;
  height: 16px;
  position: absolute;
  right: 20px;
}
.elevator-nav li.active {
  /* color: #fff; */
  background: rgba(247, 249, 225, 0.66);
  /* background: #f7f9ff; */
  border-radius: 4px;
  /* opacity: 0.66; */
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  color: raba(0, 0, 0, 0.66) !important;
}
/* .elevator-nav li:hover {
  background: #1b58ff;
  color: #fff;
} */
.elevator-nav li:not(.active) {
  background: none;
  color: #fff;
}

.main-rg {
  flex: 1;
  /* background: saddlebrown; */
  background: url('@/assets/main-rg__bg.png') no-repeat;
  background-size: 100% auto;
  background-color: #fff;
  border-radius: 4px;
}
.main-rg-top {
  /* width: 100%;
  height: 100%;
  background: url('@/assets/组 20.png') no-repeat;
  background-size: cover; */
}
.main-rg-top-img {
  width: 605px;
  height: 74px;

  background: url('@/assets/banner-pic.png') no-repeat;
  background-size: cover;
}
.main-rg-content {
  width: 605px;
  text-align: center;
  margin: 165px 0 165px 290px;
  /* padding-top: 28px; */
}
.main-rg-top-text {
  font-weight: 800;
  font-size: 26px;
  color: #000000;
  margin-top: 40px;
}
.input_inner {
  display: flex;
  align-content: center;
  margin-top: 41px;
  /* margin-bottom: 136px; */
}
.input {
  width: 800px;
  height: 48px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #1b58ff;
  margin-left: 181px;
}
.input_btn {
  width: 90px;
  height: 48px;
  background: #1b58ff;
  border-radius: 4px;
  line-height: 48px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;

  margin-left: 10px;
}

/* 列表 */
.line {
  width: 4px;
  height: 26px;
  background: #4b7bff;
  border-radius: 2px;
  margin-right: 26px;
  position: relative;
  top: 2px;
}
.list_title {
  font-weight: bold;
  font-size: 30px;
}
.list {
  display: flex;
  flex-wrap: wrap;
}
.item {
  width: 532px;
  height: 160px;

  padding: 30px 26px 0 23px;
  display: flex;
  margin-right: 21px;
  margin-bottom: 25px;
  position: relative;
  cursor: pointer;

  background: url('@/assets/bgs.png') no-repeat;
  background-size: 100% 100%;
}
.item:last-child {
  margin-right: 0;
}
.item:hover {
  border: 2px solid #1c59ff;
  box-shadow: 0px 3px 7px 0px rgba(75, 123, 255, 0.35);
}
.item-tag {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 38px;
  top: 39px;
}
.item_img {
  width: 100px;
  height: 100px;
  /* background: url('@/assets/飞语大模型.png') no-repeat;
  background-size: cover; */
  margin-right: 20px;
}
.item_rg {
  flex: 1;
}

.item_title {
  font-weight: bold;
  font-size: 26px;
  color: #333333;
  margin-bottom: 12px;
}
.item_subtitle {
  font-weight: 400;
  font-size: 14px;
  color: #6a7997;
}
.section {
  margin-left: 20px;
  margin-bottom: 60px;
}
.section-imgs {
  width: 24px;
  height: 26px;
  margin-right: 10px;
}
.footer {
  margin-left: 420px;
  margin-top: 116px;
  padding-bottom: 116px;
  position: relative;
}
.imgs {
  position: absolute;
  top: 82px;
  right: 420px;
  display: flex;
  align-items: center;
  text-align: center;
}
.imgs-s {
  margin-left: 70px;
}
.qrcode {
  width: 150px;
  height: 150px;
}

.footer-content {
}
.footer-logo {
  width: 162px;
  height: 44px;
  background: url('@/assets/logo.png') no-repeat;
  background-size: cover;
  margin-bottom: 60px;
}
.footer-text {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 4px;
}

.link {
  cursor: pointer;
}

.footer-text.texts {
  margin-bottom: 20px;
}
</style>
